<h3>Edit Amenities</h3>
@if(!loading) {
    <mat-dialog-content>
        <form [formGroup]="amenitiesForm" *ngIf="amenitiesLoaded">
            <div class="amenities-section">
            @for (cat of categories; track cat) {
                <div class="category-header"><h4>{{ cat }}</h4></div>

                <div class="checkbox-grid">
                @for (amenity of allAmenities; track amenity.id; let i = $index) {
                    @if (amenity.category === cat) {
                    <mat-checkbox
                        class="amenity-checkbox"
                        [formControl]="amenitiesGroup.at(i)">
                        <span class="amenity-name">{{ amenity.name }}</span>
                    </mat-checkbox>
                    }
                }
                </div>
            }
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-flat-button class="metallic-text-btn-red" type="button" (click)="onCancel()"><mat-icon matPrefix>cancel</mat-icon>Canel</button>
        <button mat-flat-button class="metallic-text-btn-blue" type="button" (click)="onSave()"><mat-icon matPrefix>save</mat-icon>Save</button>
    </mat-dialog-actions>
} @else {
    <div class="center">
        <div class="spinner-center">
            <app-loader></app-loader>
        </div>
        <h3>Saving Amenities...</h3>
    </div>
}